export default {
  // 页面标题
  pageTitle: 'AI获客',

  // 顶部横幅
  banner: {
    feature1: '覆盖全球各地区数据',
    feature2: '聚合各大平台和数据库资源',
    feature3: '深度挖掘联系人信息',
    feature4: '海量数据精准匹配',
    totalData: '累计全球企业数据'
  },

  // 搜索区域
  search: {
    byKeyword: '按关键词',
    byCompany: '按公司',
    byDomain: '按域名',
    uploadCustomer: '上传我的客户',
    placeholder: '可输入产品或服务的关键词进行搜索',
    searchButton: '搜索'
  },

  // AI扩展搜索词
  aiExpand: {
    title: 'AI扩展搜索词',
    expandCollapse: {
      expand: '展开',
      collapse: '收起'
    },
    description: '基于主搜索词，AI为您用',
    selectedCount: '扩展了以下相关词汇，已选择{count}个扩词',
    expandWords: '扩展词',
    languages: {
      english: '英语',
      french: '法语',
      vietnamese: '越南语',
      japanese: '日语'
    }
  },

  // 筛选条件
  filter: {
    title: '筛选条件',
    countryRegion: '国家/地区',
    selectCountry: '请选择国家或地区',
    hasEmail: '有邮箱',
    nonLogistics: '非物流公司',
    hasCustoms: '有海关数据',
    hasWebsite: '有官网',
    applyFilter: '应用筛选',
    countries: {
      china: '中国',
      usa: '美国',
      pakistan: '巴基斯坦',
      venezuela: '委内瑞拉',
      korea: '韩国',
      panama: '巴拿马',
      canada: '加拿大',
      georgia: '格鲁吉亚',
      mexico: '墨西哥',
      jamaica: '牙买加',
      ukraine: '乌克兰'
    }
  },

  // 搜索结果
  results: {
    found: '为您找到',
    resultsCount: '个结果',
    selectAll: '全选',
    oneClickMarketing: '一键营销',
    comprehensiveSort: '综合排序',
    enterpriseEmail: '企业邮箱',
    localName: '本地名称',
    establishmentDate: '成立时间',
    mainProducts: '主营产品',
    industry: '所属行业',
    businessNature: '业务性质',
    mainMarket: '主要市场',
    salesPlatform: '销售平台',
    companyProfile: '公司简介',
    businessStatus: '业务状态',
    companyType: '公司类型',
    annualRevenue: '年收入',
    aiCopy: 'AI营销',
    deepContact: '深挖联系人',
    noData: '暂无搜索结果，请尝试其他关键词'
  },

  // 上传弹窗
  upload: {
    title: '上传我的客户',
    fileTypeError: '不支持的文件类型，仅支持.xls和.xlsx格式',
    tips: '请按照模板格式上传文件，仅支持.xls和.xlsx格式',
    uploadArea: {
      title: '点击或拖拽文件到此区域上传',
      supportedFormats: '仅支持.xls和.xlsx格式',
      uploadButton: '点击上传'
    },
    buttons: {
      downloadTemplate: '下载模板',
      cancel: '取消',
      confirmUpload: '确认上传'
    },
    messages: {
      selectFile: '请先选择文件',
      maxFilesExceeded: '最多只能上传{max}个文件',
      fileSizeExceeded: '文件 {files} 大小超过10MB',
      uploadSuccess: '成功上传 {count} 个文件',
      allFailed: '所有文件上传失败，请重试',
      partialFailed: '部分文件上传失败：{files}',
      uploadFailed: '上传失败，请重试',
      downloadTemplateSuccess: '模板下载成功',
      downloadTemplateFailed: '下载模板失败，请重试'
    }
  },

  // AI文案生成
  aiCopy: {
    title: 'AI营销文案生成',
    recipients: '收件人',
    recipientDetails: '收件人详情',
    outputLength: '输出长度',
    outputTone: '输出语气',
    outputLanguage: '输出语言',
    emailType: '邮件类型',
    lengths: {
      auto: '自动',
      short: '短',
      medium: '中等',
      long: '长'
    },
    tones: {
      auto: '自动',
      friendly: '友善',
      formal: '正式',
      amiable: '友好',
      professional: '专业',
      funny: '有趣'
    },
    languages: {
      chinese: '中文',
      english: '英语'
    },
    contentTypes: {
      ratePromotion: '运价推广',
      developmentLetter: '开发信'
    },
    rateSelection: {
      pol: '起运港',
      pod: '目的港',
      carrier: '船公司',
      selectPol: '请选择起运港',
      selectPod: '请选择目的港',
      selectCarrier: '请选择船公司',
      query: '查询',
      selectRates: '选择运价',
      shipCompany: '船公司',
      etd: '预计离港',
      voyageDays: '航程',
      vessel: '船名',
      voyage: '航次',
      validPeriod: '有效期',
      loading: '加载中...',
      noData: '暂无运价信息，请先查询',
      allLoaded: '已加载全部数据',
      loadedCount: '加载了 {count} 条运价数据'
    },
    buttons: {
      copy: '一键复制',
      generate: '开始生成',
      confirmAndSend: '确认并发送',
      close: '关闭窗口',
      viewEmails: '查看邮件'
    },
    generatedTitle: '主题',
    generatedContent: '生成的营销文案',
    messages: {
      selectRate: '请先选择运价信息',
      dataLoading: '基础数据正在加载中，请稍候再试',
      generateSuccess: '内容生成成功',
      generateFailed: '生成失败，请重试',
      generateEmpty: '生成内容为空',
      copySuccess: '复制成功',
      copyFailed: '复制失败，请重试',
      queryFailed: '运价查询失败，请重试',
      sendSuccess: '邮件已成功发送!',
      sendFailed: '邮件发送失败，请重试',
      sending: '正在发送邮件...',
      noRecipients: '请先添加收件人',
      noTitle: '请先输入邮件主题',
      noContent: '请先生成邮件内容'
    },
    sendSuccess: {
      title: '邮件已成功发送!',
      description: '您的营销邮件已成功发送给所有收件人',
      subject: '主题',
      recipientCount: '收件人数量',
      recipients: '个收件人',
      emailType: '邮件类型',
      marketingEmail: '运价推广邮件',
      sendTime: '发送时间',
      emailInfo: '邮件信息',
      more: '更多',
      defaultSubject: 'AI营销邮件'
    },
    recipientModal: {
      searchPlaceholder: '搜索收件人邮箱',
      addEmailPlaceholder: '输入邮箱地址',
      addButton: '添加',
      deleteButton: '删除',
      closeButton: '关闭',
      noRecipients: '暂无收件人',
      manualAdd: '手动添加',
      customerInfo: '客户：{customerName} | 联系人：{contactName}',
      customerLabel: '客户',
      contactLabel: '联系人',
      emailFormatError: '邮箱格式不正确',
      emailExists: '邮箱已存在',
      addSuccess: '添加成功',
      deleteSuccess: '删除成功',
      editSuccess: '修改成功',
      moreRecipients: '+{count}更多',
      establishmentDate: '成立时间',
      employeeCount: '员工人数',
      contactPhone: '联系电话'
    }
  },

  // 联系人信息
  contact: {
    title: '联系人信息',
    company: '公司',
    position: '岗位',
    department: '部门',
    email: '联系人邮箱',
    phone: '联系人电话',
    noContacts: '暂无联系人信息',
    closeButton: '关闭'
  },

  // 通用消息
  messages: {
    searchEmpty: '请输入搜索内容',
    searchSuccess: '为您找到 {count} 个结果',
    searchFailed: '搜索失败，请重试'
  },

  // 单位
  units: {
    days: '天',
    tenThousandYuan: '万元',
    count: '个',
    person: '人'
  }
}
